import {
  PageContentLayout,
  PageHeaderLayout,
  Loader,
  SideMenu,
  Typography,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'config';
import { COLOR_BY_STATUS, useSurvey, useSurveyResults } from 'store/surveys';
import { useRouteParams } from 'utils/useIdParam';
import { useRouteMatch } from 'react-router-dom';
import { SurveyActions } from 'containers/surveys';
import { useMe } from 'state/Administrators';

export const SurveyResultsLayout: FC = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const { id: surveyId } = useRouteParams(ROUTES.surveys.survey.details);
  const { hasViewPermission } = useMe();

  const { data: results, isLoading: isResultsLoading } =
    useSurveyResults(surveyId);
  const { data: survey, isLoading: isSurveyLoading } = useSurvey(surveyId);

  if (isResultsLoading || isSurveyLoading) return <Loader />;
  if (!results || !survey) return null;

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t(`surveys.type.${survey.type}.title`),
            url: ROUTES.surveys[survey.type].list,
          },
          {
            label: survey.name,
          },
        ]}
        side={<SurveyActions survey={survey} results={results} />}
        under={
          <Stack direction="row" gap={2}>
            <Typography variant="h3" color={COLOR_BY_STATUS[results.status]}>
              {t(`surveys.status-${results.status}`)}
            </Typography>
            {results.anonymous ? (
              <Typography variant="p1" color="textSecondary">
                {t('surveys.anonymousSurvey')}
              </Typography>
            ) : null}
          </Stack>
        }
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'details',
                label: t('benefitExpenses.summary'),
                url: ROUTES.surveys[survey.type].results.replace(
                  ':id',
                  surveyId,
                ),
                isActive: path === ROUTES.surveys[survey.type].results,
              },
              ...(['training'].includes(survey.type) &&
              hasViewPermission(['employees'])
                ? [
                    {
                      key: 'submissions',
                      label: t('surveys.submissions.title'),
                      url: ROUTES.surveys[survey.type].submissions.list.replace(
                        ':id',
                        surveyId,
                      ),
                      isActive:
                        path === ROUTES.surveys[survey.type].submissions.list ||
                        path ===
                          ROUTES.surveys[survey.type].submissions.pending.list,
                    },
                  ]
                : []),
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
